import { PaintedScene, type PaintedSceneInitData } from './PaintedScene';
import type { PaintedSceneAssetSpec } from './sceneAssetSpec.schema';
import type { JourneyManifest } from './journeyManifest.schema';

export const LAKESIDE_STONES_SCENE_PHASER_KEY = 'LakesideStonesScene' as const;
export const LAKESIDE_STONES_SCENE_MANIFEST_KEY = 'scene-4-lakeside-stones' as const;

export class LakesideStonesScene extends PaintedScene {
  constructor() {
    super(LAKESIDE_STONES_SCENE_PHASER_KEY, LAKESIDE_STONES_SCENE_MANIFEST_KEY);
  }

  protected provideAssetSpec(): PaintedSceneAssetSpec | null {
    return null;
  }

  protected provideManifest(): JourneyManifest | null {
    return null;
  }

  init(data?: PaintedSceneInitData): void {
    super.init(data);
  }
}
